import { render, staticRenderFns } from "./PageViewEvidence.vue?vue&type=template&id=2e86a5d6&scoped=true&"
import script from "./PageViewEvidence.vue?vue&type=script&lang=js&"
export * from "./PageViewEvidence.vue?vue&type=script&lang=js&"
import style0 from "./PageViewEvidence.vue?vue&type=style&index=0&id=2e86a5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e86a5d6",
  null
  
)

export default component.exports